<template>
  <div>
    <!-- 顶部banner -->
    <banner :image="require(`@/assets/solution/banner3.jpg`)"  :fontText="fontText" />
    <!-- 一 -->
    <div class="floor-store floor-tab-height1500">
      <div data-aos="fade-up">
        <div>
          <div class="title">
            门店业务场景全覆盖
          </div>
          <div style="font-size: 16px; color: #595859; line-height: 21px">
            实现收银、门店、采购、商城、供应链管理一体化
          </div>
        </div>
        <div class="retailForEach">
          <div v-for="(item,index) in storeList" :key="index" class="store-item">
            <img :src="item.icon" alt="">
            <div class="store-item-title">{{item.title}}</div>
            <div class="store-item-content" v-html="item.content"></div>
          </div>
        </div>
        <div class="industry-container">
          <img src="@/assets/solution/storeOne.jpg" alt="" />
        </div>
      </div>
    </div>
    <!-- 二 -->
    <div class="floor-store floorColor floor-tab-height700">
      <div>
        <div data-aos="fade-up">
          <div class="title">
            智慧门店解决方案核心价值
          </div>
          <div style="font-size: 16px; color: #595859; line-height: 21px">
            大数据精准分析，全渠道业务融合，互动体验式购物
          </div>
        </div>
        <div class="flex-container" data-aos="fade-up">
          <div  class="flex-container-item">
            <img src="@/assets/solution/storeNum1.png" alt="" />
            <div class="flex-container-title">
               会员运营大数据
            </div>
            <div class="flex-container-cont">
              <div class="flex-container-cont-item">
                <img src="@/assets/solution/correctIcon.png" alt="">
                <div class="flex-container-cont-font">精准人群标签</div>
              </div>
              <div class="flex-container-cont-item">
                <img src="@/assets/solution/correctIcon.png" alt="">
                <div class="flex-container-cont-font">大数据精准营销</div>
              </div>
              <div class="flex-container-cont-item">
                <img src="@/assets/solution/correctIcon.png" alt="">
                <div class="flex-container-cont-font">360度消费者画像</div>
              </div>
              <div class="flex-container-cont-item">
                <img src="@/assets/solution/correctIcon.png" alt="">
                <div class="flex-container-cont-font">会员全生命周期关怀</div>
              </div>
            </div>
          </div>
          <div  class="flex-container-item">
            <img src="@/assets/solution/storeNum2.png" alt="" />
            <div class="flex-container-title">
              AI互动体验
              
            </div>
            <div class="flex-container-cont">
              <div class="flex-container-cont-item flex-item2">
                <img src="@/assets/solution/correctIcon.png" alt="">
                <div class="flex-container-cont-font">虚拟试用</div>
              </div>
              <div class="flex-container-cont-item flex-item2">
                <img src="@/assets/solution/correctIcon.png" alt="">
                <div class="flex-container-cont-font">人脸识别</div>
              </div>
              <div class="flex-container-cont-item flex-item2">
                <img src="@/assets/solution/correctIcon.png" alt="">
                <div class="flex-container-cont-font">互动游戏</div>
              </div>
              <div class="flex-container-cont-item flex-item2">
                <img src="@/assets/solution/correctIcon.png" alt="">
                <div class="flex-container-cont-font">自动收银</div>
              </div>
              <div class="flex-container-cont-item flex-item2">
                <img src="@/assets/solution/correctIcon.png" alt="">
                <div class="flex-container-cont-font">云货架</div>
              </div>
              <div class="flex-container-cont-item flex-item2">
                <img src="@/assets/solution/correctIcon.png" alt="">
                <div class="flex-container-cont-font">红包抽奖</div>
              </div>
              <div class="flex-container-cont-item flex-item2">
                <img src="@/assets/solution/correctIcon.png" alt="">
                <div class="flex-container-cont-font">公众号透出</div>
              </div>
            </div>
          </div>
          <div  class="flex-container-item">
            <img src="@/assets/solution/storeNum3.png" alt="" />
            <div class="flex-container-title">
              全渠道业务融合
            </div>
            <div class="flex-container-cont" style="display: block;width: 220px;margin: auto;">
              <div class="flex-container-cont-item">
                <img src="@/assets/solution/correctIcon.png" alt="">
                <div class="flex-container-cont-font">线下引流，门店吸粉</div>
              </div>
              <div class="flex-container-cont-item">
                <img src="@/assets/solution/correctIcon.png" alt="">
                <div class="flex-container-cont-font">线上下单，门店发货</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 三 -->
    <div class="floor-store-bg floor-tab-height750">
      <div>
        <div data-aos="fade-up">
          <div class="title">
            核心能力
          </div>
          <div style="font-size: 16px; color: #fff; line-height: 21px;opacity: 0.7;">
            实现引流、进店、导购、结算、离店运营闭环
          </div>
        </div>
        <div class="retailForEach" style="flex-wrap: wrap;" data-aos="fade-up">
          <div v-for="(item,index) in storeTwoList" :key="index" class="store-item-three">
            <img :src="item.icon" alt="">
            <div class="store-item-three-title">{{item.title}}</div>
            <div class="store-item-three-content" v-html="item.content"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 四 -->
    <div class="floor-store floorColor floor-tab-height840">
      <div>
        <div data-aos="fade-up">
          <div class="title">
            平台架构
          </div>
        </div>
        <div class="industry-container" data-aos="fade-up">
          <img src="@/assets/solution/storeTwo.png" alt="" />
        </div>
      </div>
    </div>
    <!-- 五 -->
    <div class="floor-store floor-tab-height600">
      <div>
        <div data-aos="fade-up">
          <div class="title">
            智慧零售
          </div>
          <div style="font-size: 16px; color: #595859; line-height: 21px">
            帮助每一位重视服务和体验的商家建立私域流量，提升客户消费体验，推动客户持续到店创造终身价值
          </div>
        </div>
        <div class="financial-container-two" data-aos="fade-up">
          <img src="@/assets/solution/storeNum4.png" alt="" />
          <div class="financial-content-two">
            <div class="financial-content-item-two">
              <img src="@/assets/solution/correctIcon.png" alt="" />
              <div>
                <div class="financial-content-title">链接</div>
                <div class="financial-item-content">无缝链接全国各地直营、联营、加盟店实现精细化运营</div>
              </div>
            </div>
            <div class="financial-content-item-two">
              <img src="@/assets/solution/correctIcon.png" alt="" />
              <div>
                <div class="financial-content-title">绑定</div>
                <div class="financial-item-content">绑定线上线下全渠道绩效，让店长、导购创造更多的价值</div>
              </div>
            </div>
            <div class="financial-content-item-two">
              <img src="@/assets/solution/correctIcon.png" alt="" />
              <div>
                <div class="financial-content-title">融合</div>
                <div class="financial-item-content">融合多种智能硬件设备，打造多种消费体验场景</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 六 -->
    <div class="floor-store floor-tab-height840">
      <div>
        <div data-aos="fade-up">
          <div class="title" style="padding-top: 120px !important;">
            智慧导购管理
          </div>
          <div style="font-size: 16px; color: #595859; line-height: 21px">
            丰富的营销玩法，满足商家不同时期、不同阶段、不同场景下的使用需求，让工具随时随地都给力，帮助商家制胜社交运营
          </div>
        </div>
        <div class="financial-container-two imgHeight470" data-aos="fade-up">
          <div class="financial-content-two" style="margin-top: 10px;">
            <div class="financial-content-item-two">
              <img src="@/assets/solution/correctIcon.png" alt="" />
              <div>
                <div class="financial-content-title">绑定业绩 · 激活导购</div>
                <div class="financial-item-content">导购专属二维码，线上线下业绩绑定到人；业务数据竞比排名，持续激发业绩增长</div>
              </div>
            </div>
            <div class="financial-content-item-two">
              <img src="@/assets/solution/correctIcon.png" alt="" />
              <div>
                <div class="financial-content-title">用户画像 · 精准营销</div>
                <div class="financial-item-content">多维度制定用户画像标签，通过画像标签分析，实现营销内容精准送</div>
              </div>
            </div>
            <div class="financial-content-item-two">
              <img src="@/assets/solution/correctIcon.png" alt="" />
              <div>
                <div class="financial-content-title">分享销售 · 促进成交</div>
                <div class="financial-item-content">导购可一键推送商品、海报、优惠券等内容,分享销售促进成交，洞察客户收藏订单</div>
              </div>
            </div>
            <div class="financial-content-item-two">
              <img src="@/assets/solution/correctIcon.png" alt="" />
              <div>
                <div class="financial-content-title">导购任务 · 自动生成</div>
                <div class="financial-item-content">根据会员动态设定导购任务，提醒导购即时回放并维护会员∶如生日<br/>回访、消费回访等</div>
              </div>
            </div>
          </div>
          <img src="@/assets/solution/storeNum5.png" style="height: 470px;" alt="" />
        </div>
      </div>
    </div>
    <!-- 七 -->
    <div class="floor-store floorBg floor-tab-height840">
      <div>
        <div data-aos="fade-up">
          <div class="title">
            AI人脸识别应用
          </div>
        </div>
        <div class="industry-container positionBox" data-aos="fade-up">
          <img src="@/assets/solution/storeThr.jpg" alt="" />
          <div class="positionBox-content">
            <div class="financial-content-item-two">
              <img src="@/assets/solution/correctIcon.png" style="width: 22px;" alt="" />
              <div>
                <div class="financial-content-title">{{`进店提醒  识别顾客`}}</div>
              </div>
            </div>
            <div class="financial-content-item-two" style="margin-left: 60px;">
              <img src="@/assets/solution/correctIcon.png" style="width: 22px;" alt="" />
              <div>
                <div class="financial-content-title">{{`会员画像  购物足迹`}}</div>
              </div>
            </div>
            <div class="financial-content-item-two" style="margin-left: 120px;">
              <img src="@/assets/solution/correctIcon.png" style="width: 22px;" alt="" />
              <div>
                <div class="financial-content-title">{{`选品建议  精准营销`}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 八 -->
    <div class="floor-store floor-tab-height800">
      <div>
        <div data-aos="fade-up">
          <div class="title">
            智慧云仓
          </div>
          <div style="font-size: 16px; color: #595859; line-height: 21px">
            智慧化的云端仓储，相比于普通仓库，仓库利用率提高2.5倍，人工效率提高5倍，拣选准确率可达90%以上
          </div>
        </div>
        <div class="financial-container-two imgHeight470" style="margin-top: 10px;display: block;" data-aos="fade-up">
          <div class="financial-content-two" style="display: flex;justify-content: space-between;width: 100%;">
            <div class="financial-content-item-two">
              <img src="@/assets/solution/correctIcon.png" alt="" />
              <div>
                <div class="financial-content-title">提高供应链运作效率</div>
                <div class="financial-item-content">采用就近发货原则，大大缩短了发货的运输周期，降低物流成本</div>
              </div>
            </div>
            <div class="financial-content-item-two">
              <img src="@/assets/solution/correctIcon.png" alt="" />
              <div>
                <div class="financial-content-title">门店试用线上下单</div>
                <div class="financial-item-content">门店缺货，在门店扫码进入在线商城直接购买，由其他门店发货给客户</div>
              </div>
            </div>
            <div class="financial-content-item-two">
              <img src="@/assets/solution/correctIcon.png" alt="" />
              <div>
                <div class="financial-content-title">灵活管控库存积压</div>
                <div class="financial-item-content">共享库存模式可优先处理积压库存的门店或仓库，合理控制安全库存</div>
              </div>
            </div>
          </div>
          <img src="@/assets/solution/storeFour.png" style="width:100%;height: 350px;" alt="" />
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>
<script>
import Footer from '../../components/Footer'
import banner from './components/banner'
import floorTwo from './components/floor2'

export default {
  name: "store",
  components: {
    floorTwo,
    Footer,
    banner
  },
  data() {
    return {
      fontText: {
        title: '智慧门店解决方案',
        txtMiddle: [
          '用科技和数据赋能实体门店',
          '融合人工智能、物联网、云计算等先进技术',
          '重构门店人、货、场',
          '全面提升消费体验和门店效率'
        ]
      },
      storeList: [
        {
          icon: require("@/assets/menu/product-icon-5.svg"),
          title: '极速收银',
          content: '<span>智慧多端收银<br/>门店收银提效60% </span>'
        },
        {
          icon: require("@/assets/solution/tabThrIcon1.png"),
          title: '门店助手',
          content: '<span>传统门店ERP升级<br/>高效处理门店业务</span>'
        },
        {
          icon: require("@/assets/menu/product-icon-2.svg"),
          title: '采购助手',
          content: '<span>移动化经营，同步门店<br/>实现精准采购</span>'
        },
        {
          icon: require("@/assets/menu/product-icon-3.svg"),
          title: '线上商城',
          content: '<span>一套解决线上管理<br/>对接外卖、自营会员</span>'
        },
        {
          icon: require("@/assets/product/icon/scrmIcon4.png"),
          title: '智慧供应链',
          content: '<span>供应商供应链智慧调节<br/>解决连锁问题</span>'
        }
      ],
      storeTwoList: [
        {
          icon: require("@/assets/solution/retailIcon1.png"),
          title: '收银系统',
          content: '<span>移动收银、货品收银，灵活促销<br/>退换货，日结等</span>'
        },
        {
          icon: require("@/assets/solution/tabTwoIcon2.png"),
          title: '库存管理',
          content: '<span>库存查询，盘点，损益、预警等</span>'
        },
        {
          icon: require("@/assets/solution/tabTwoIcon6.png"),
          title: '报表查询',
          content: '<span>店铺日常报表查看，零售情况<br/>畅滞销，同比环比等</span>'
        },
        {
          icon: require("@/assets/solution/tabTwoIcon7.png"),
          title: '会员管理',
          content: '<span>会员开卡，促销，积分消费<br/>储值，生日活动等</span>'
        },
        {
          icon: require("@/assets/solution/tabTwoIcon8.png"),
          title: '店长魔方',
          content: '<span>日周月报，公告，业务流提醒、销售KPI<br/>会员分析，智能预警</span>'
        },
        {
          icon: require("@/assets/solution/retailIcon3.png"),
          title: '店务管理',
          content: '<span>补货，调拨，货品进出库等</span>'
        },
      ],
    };
  },
  methods: {
    // 当鼠标进入元素时触发
    // handleMouseEnter(index) {
    //   // console.log('鼠标进入了元素' + index);
    //   this.industrySelecedIndex = index;
    // },
    // 当鼠标离开元素时触发
    // handleMouseLeave(index) {
    //   // console.log('鼠标离开了元素');
    // },
  },
};
</script>

<style lang="less" scoped>
.floor-store {
  width: 100%;
  height: 920px;
  background: #fff;
}
.floorBg{
  background: linear-gradient(180deg, #F2F7FF, #CFE3FF);
}
.floor-store .title{
  font-weight: bold; font-size: 32px; color: #222222;padding-top: 80px;margin-bottom: 14px;
}
.floor-store .retailForEach{
  width: 1200px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
}
.floor-store-bg .retailForEach{
  width: 1200px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
}
.store-item{
  width: 224px;
  height: 200px;
  margin: auto;
  background: linear-gradient(180deg, #FAFCFF, #ECF2FF);
  border-radius: 6px;
}

.store-item img{
  width: 40px;
  height: 40px;
  margin-top: 30px;
  margin-bottom: 18px;
}
.store-item-title{
  font-size: 18px;
  color: #222222;
  font-weight: bold;
  margin-bottom: 12px;
}
.store-item-content{
  /* padding: 0 50px; */
  color: #595859;
  font-size: 14px;
  line-height: 22px;
}
.floor-store .industry-container{
  padding-top: 35px;
  width: 1200px;
  margin: auto;
}
.floor-store .industry-container img{
  width: 100%;
}

.floorColor{
  background: #F4F5FB;
}
.floor-store-bg{
  width: 100%;
  height: 950px;
  background: url('../../assets/solution/floorBg3.png') no-repeat center center;
  background-size: 1920px 100%;
  background-color: #0B4FD1;
  
}
.store-item-three{
  background: #FFFFFF;
  width: 380px;
  height: 200px;
  border-radius: 6px;
  margin-bottom: 30px;
  padding: 40px;
}
.store-item-three img{
  width: 40px;
  height: 40px;
}
.store-item-three-title{
  color: #222222;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 12px;
  margin-top: 18px;
}
.store-item-three-content{
  color: #595859;
  font-size: 14px;
  line-height: 20px;
}
.positionBox{
  position: relative;
}
.positionBox-content{
  position: absolute;
  right: 170px;
  top: 80px;
}
.floor-store-bg .industry-container{
  padding-top: 35px;
  width: 1200px;
  margin: auto;
}
.floor-store-bg .industry-container img{
  width: 100%;
}
.floor-store-bg  .title{
  font-weight: bold; font-size: 32px; color: #FFFFFF;padding-top: 80px;margin-bottom: 14px;
}
.floor-tab-height{
  height: 1000px;
}
.floor-tab-height840{
  height: 840px;
}
.floor-tab-height750{
  height: 750px;
}
.floor-tab-height800{
  height: 800px;
}
.floor-tab-height700{
  height: 700px;
}
.floor-tab-height600{
  height: 600px;
}
.floor-tab-height950{
  height:950px;
}
.floor-tab-height1500{
  height:1500px;
}
.financial-container-two{
  width: 1200px;
  margin: auto;
  margin-top: 45px;
  display: flex;
  justify-content: space-between;
}
.financial-container-two img{
  width: 600px;
  /* height: 480px; */
}
.imgHeight470 img{
  height: 470px;
}
.financial-content-two{
  width: 490px;
  margin-top: 38px;
}
.financial-content-item-two{
  text-align: left;
  display: flex;
  margin-bottom: 10px;
  margin-right:30px ;
  &:last-child{
    margin-right: 0;
  }
}
.financial-content-item-two img{
  width: 22px;
  height: 16px;
  margin-top: 8px;
  margin-right: 10px;
}
.financial-content-title{
  color: #222222;
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 14px;
}
.financial-item-content{
  color: #595859;
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 36px;
}
.flex-container{
  width: 1200px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  margin-top: 45px;
}
.flex-container-item{
  width: 380px;
  height: 390px;
  background: #FFFFFF;
  border-radius: 6px;
}
.flex-container-item img{
  width: 340px;
  height: 170px;
  margin: auto;
  margin-top: 20px;
  margin-bottom: 20px;
}
.flex-container-title{
  color: #222222;
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 25px;
}
.flex-container-cont{
  display: flex;
  justify-content: space-between;
  padding: 0 30px;
  flex-wrap: wrap;
}
.flex-container-cont-item{
  display: flex;
  margin-bottom: 20px;
  width: 160px;
}
.flex-item2{
  width: 100px;
}
.flex-container-cont-item img{
  width: 22px;
  height: 16px;
  margin: 0;
}
.flex-container-cont-font{
  margin-left: 6px;
  color: #222222;
  font-size: 14px;
}

</style>
